// Productivity — the top-nav Reports page's admin-only tab, moved to Live Reporting (step 8 part 6, decision I). A CARD
// definition with its own component, shown to admins only (adminOnly: the picker hides it and the page won't render it).
import Productivity from '../cards/Productivity';

const productivity = {
  id: 'productivity',
  title: 'Productivity',
  description: 'Per staffer: tasks completed, deadlines met and missed, and open work today, over a date range.',
  adminOnly: true,
  component: Productivity,
};

export default productivity;
